import React, { useEffect, useState } from "react";
import Airtable from "airtable";
import { Table, Button, Form } from "react-bootstrap";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import Select from "react-select";
import logo from "./logo-sigal_3.png";

// const MAX_DISCOUNT_PERCENT = 25;

let base = new Airtable({
	apiKey:
		"patBXQgJPv4W41ktc.c7c4725c447b5fbef08fcd945de907f7ff20eb53ee6213c0f546fc811def4547",
}).base("appzz2xABAjzkSNOs");

function SmallSizes() {
	const [data, setData] = useState([]);
	//const [vendors, setVendors] = useState([]);
	const [suppliers, setSuppliers] = useState([]);
	const [selectedSupplier, setSelectedSupplier] = useState("");
	//const [selectedVendor, setSelectedVendor] = useState("");
	const [rows, setRows] = useState({
		בוגרים: [],
		ילדים: [],
		נעליים: [],
		"מוצרי פרסום": [],
		"דפוס ומשרד": [],
	});
	//const [url, setUrl] = useState("");
	const [commentsField, setCommentsField] = useState("");
	const [taxPercent, setTaxPercent] = useState(0.18);

	const [rowsToDelete, setRowsToDelete] = useState([]);

	const [orderDone, setOrderDone] = useState({
		done: false,
		orderId: "",
		updateUrl: "",
		approveOrderUrl: "",
		whatsappLink: "",
		mailLink: "",
	});

	const [loadOrderData, setLoadOrderData] = useState({});

	//Component did mount/Update
	useEffect(() => {
		loadItems();
		// loadVendors();
		loadSuppliers();
	}, []);

	useEffect(() => {
		if (orderDone.done) {
			getApproveOrderUrl(orderDone.orderId);
		}
		// eslint-disable-next-line
	}, [orderDone.done]);

	const loadVendors = () => {
		let vendorsArray = [];
		base("סוכנים")
			.select({
				view: "הכל",
			})
			.eachPage(
				function page(records, fetchNextPage) {
					records.forEach(function (record) {
						vendorsArray.push(record);
					});
					fetchNextPage();
				},
				function done(err) {
					if (err) {
						console.error(err);
						return;
					}

					//setVendors([...vendorsArray]);
				}
			);
	};

	const loadSuppliers = () => {
		let suppliersArr = [];
		base("ספקים")
			.select({
				view: "Grid view",
			})
			.eachPage(
				function page(records, fetchNextPage) {
					records.forEach(function (record) {
						suppliersArr.push(record);
					});
					fetchNextPage();
				},
				function done(err) {
					if (err) {
						console.error(err);
						return;
					}

					setSuppliers([...suppliersArr]);
				}
			);
	};

	const loadOrder = () => {
		if (!loadOrderData.orderId || loadOrderData.orderId === "") {
			alert("אנא מלאו מספר הזמנה");
			return;
		}

		base("הזמנות ספקים")
			.select({
				view: "הכל",
				filterByFormula: `{מס הזמנה} = '${loadOrderData.orderId}'`,
			})
			.firstPage(function (err, records) {
				if (err) {
					console.error(err);
					return;
				}
				if (records.length === 0) {
					alert("לא נמצאה הזמנה מתאימה.");
					return;
				}

				let returnedId = records[0].getId();
				let returnedOrderId = records[0].fields["מס הזמנה"];
				let returnedUpdateUrl = records[0].fields["iframeUpdateOrderForm"];
				let commentsFieldData = records[0].fields["הערות להזמנה"];
				let taxPercentData = records[0].fields["taxPercent"];

				let approveWarehouse = records[0].fields["מאושר מחסן"];
				if (approveWarehouse === true) {
					alert("לא ניתן לערוך הזמנה זו (ההזמנה כבר אושרה במחסן)");
					return;
				}

				// setSelectedVendor(records[0].fields["סוכנים"][0]);
				setSelectedSupplier(records[0].fields["ספק"][0]);
				setCommentsField(commentsFieldData);
				setTaxPercent(taxPercentData);
				setLoadOrderData({
					...loadOrderData,
					loadedOrderId: records[0].fields["מס הזמנה"],
					loadedRecId: returnedId,
					updateUrl: returnedUpdateUrl,
					checkApproveText: records[0].fields["checkApproveText"],
				});
				getOrderRows(returnedOrderId);
			});
	};

	const getApproveOrderUrl = (orderId) => {
		base("הזמנות ספקים")
			.select({
				view: "הכל",
				filterByFormula: `{מס הזמנה} = '${orderId}'`,
			})
			.firstPage(function (err, records) {
				if (err) {
					console.error(err);
					return;
				}
				if (records.length === 0) {
					return;
				}

				let approveOrderUrl = records[0].fields["checkApproveText"];
				let whatsappLink = records[0].fields["whatsappLink"];
				let mailLink = records[0].fields["mailLink"];
				let commentsFieldData = records[0].fields["הערות להזמנה"];
				if (!approveOrderUrl) approveOrderUrl = "";

				setOrderDone({
					...orderDone,
					approveOrderUrl: approveOrderUrl,
					whatsappLink: whatsappLink,
					mailLink: mailLink,
				});
				setCommentsField(commentsFieldData);
			});
	};

	const getOrderRows = (returnedId) => {
		let array = [];
		let objParsed = {
			ילדים: [],
			בוגרים: [],
			נעליים: [],
			הדפסים: [],
			"מוצרי פרסום": [],
			"דפוס ומשרד": [],
		};
		base("פריטי הזמנות ספקים")
			.select({
				view: "API",
				filterByFormula: `{הזמנה} = '${returnedId}'`,
			})
			.eachPage(
				function page(records, fetchNextPage) {
					records.forEach(function (record) {
						const type = record.fields["type"];
						const rawType = record.fields["rawType"];
						array.push(record);
						objParsed[rawType].push({
							recId: record.getId(),
							id: record.fields["פריט"][0],
							comments: record.fields["הערות/תיאור עבודה"],
							clientOrderId: record.fields["מספר הזמנת ללקוח"],
							location: record.fields["מיקום אספקה"],
							printColorId: record.fields["צבע הדפסה"],
							price: record.fields["מחיר"],
							amount: record.fields["amount"],
							sizes: {
								2: record.fields["2"],
								s: record.fields["S/39/4"],
								m: record.fields["M/40/6"],
								l: record.fields["L/41/8"],
								xl: record.fields["XL/42/10"],
								"2xl": record.fields["2XL/43/12"],
								"3xl": record.fields["3XL/44/14"],
								"4xl": record.fields["4XL/45/16"],
								"5xl": record.fields["5XL/46/18"],
								"s-36": record.fields["36"],
								"s-36-5": record.fields["36-5"],
								"s-37": record.fields["37"],
								"s-37-5": record.fields["37-5"],
								"s-38": record.fields["38"],
								"s-38-5": record.fields["38-5"],
								"s-39-5": record.fields["39-5"],
								"s-40-5": record.fields["40-5"],
								"s-41-5": record.fields["41-5"],
								"s-42-5": record.fields["42-5"],
								"s-43-5": record.fields["43-5"],
								"s-44-5": record.fields["44-5"],
								"s-45-5": record.fields["45-5"],
								"s-46-5": record.fields["46-5"],
								"s-47": record.fields["47"],
								"s-47-5": record.fields["47-5"],
								"s-48": record.fields["48"],
								oneSize: record.fields["One Size"],
							},
							colorId: record.fields["צבע"],
							checkboxData: record.fields["תפירה?"],
							isRikma: record.fields["רקמה?"],
							isPrinting: record.fields["הדפסה?"],
							type: type,
							rawType: rawType,
						});
					});
					fetchNextPage();
				},
				function done(err) {
					if (err) {
						console.error(err);
						return;
					}

					setRows(objParsed);
				}
			);
	};

	const loadItems = () => {
		let array = [];

		base("פריטים ספקים")
			.select({
				view: "הכל",
			})
			.eachPage(
				function page(records, fetchNextPage) {
					records.forEach(function (record) {
						array.push(record);
					});
					fetchNextPage();
				},
				function done(err) {
					if (err) {
						console.error(err);
						return;
					}

					setData([...array]);
				}
			);
	};

	const getSupplierData = () => {
		if (!selectedSupplier || selectedSupplier === "") return {};

		let record = suppliers.filter((item) => selectedSupplier === item.id);
		if (record) {
			return record[0].fields;
		}
		return {};
	};

	const getProductPrice = (idx, type) => {
		if (
			!rows[type] ||
			!rows[type][idx] ||
			!rows[type][idx].id ||
			rows[type][idx].id === ""
		)
			return 0;

		let itemId = rows[type][idx].id;
		let record = data.filter((item) => itemId === item.id);

		if (record) {
			return record[0].fields.price;
		}
		return 0;
	};

	const getProduct = (idx, type) => {
		if (
			!rows[type] ||
			!rows[type][idx] ||
			!rows[type][idx].id ||
			rows[type][idx].id === ""
		)
			return {};

		let itemId = rows[type][idx].id;
		let record = data.filter((item) => itemId === item.id);
		console.log(record);

		if (record) {
			return record[0].fields;
		}
		return {};
	};

	// const getProductMaxPrice = (basePrice) => {
	// 	return basePrice - (basePrice * MAX_DISCOUNT_PERCENT) / 100;
	// };

	const ColorSelector = ({ itemId }) => {
		let options = [];
		if (itemId) {
			let record = data.filter((item) => itemId === item.id);
			if (record && record[0].fields["צבעים"]) {
				options = record[0].fields["צבעים"];
			}
		}

		return options.map((item, index) => {
			return (
				<option key={"color" + index} value={item}>
					{item}
				</option>
			);
		});
	};

	const sizeChanged = (e, idx, type) => {
		let size = e.target.getAttribute("data-size");

		let newRowsType = [...rows[type]];
		if (newRowsType[idx].sizes == null) newRowsType[idx].sizes = {};
		newRowsType[idx].sizes[size] = e.target.value;

		const newRows = { ...rows };
		newRows[type] = newRowsType;
		setRows(newRows);
	};

	const updateRows = async () => {
		let checkApproveText = "";
		let whatsappLink = "";
		let mailLink = "";
		try {
			let record = await base("הזמנות ספקים").update([
				{
					id: loadOrderData.loadedRecId,
					fields: {
						"הערות להזמנה": commentsField,
						"הזמנה תוקנה": true,
					},
				},
			]);
			checkApproveText = record[0].fields["checkApproveText"];
			whatsappLink = record[0].fields["whatsappLink"];
			mailLink = record[0].fields["mailLink"];
		} catch (err) {
			console.error(err);
			return;
		}

		if (rowsToDelete.length > 0)
			base("פריטי הזמנות ספקים").destroy(
				rowsToDelete,
				function (err, deletedRecords) {
					if (err) {
						console.error(err);
						return;
					}
					console.log("Deleted", deletedRecords.length, "records");
				}
			);

		setRowsToDelete([]);

		var rowsToUpdate = [];

		rowsToUpdate = getAllRows().map((row) => {
			return {
				id: row.recId,
				fields: {
					פריט: [row.id],
					"הערות/תיאור עבודה": row.comments,
					"מספר הזמנת לקוח": row.clientOrderId,
					"מיקום אספקה": row.location,
					"צבע הדפסה": row.printColorId,
					צבע: row.colorId,
					מחיר: row.price,
					2: parseInt(row.sizes["2"]),
					"S/39/4": parseInt(row.sizes["s"]),
					"M/40/6": parseInt(row.sizes["m"]),
					"L/41/8": parseInt(row.sizes["l"]),
					"XL/42/10": parseInt(row.sizes["xl"]),
					"2XL/43/12": parseInt(row.sizes["2xl"]),
					"3XL/44/14": parseInt(row.sizes["3xl"]),
					"4XL/45/16": parseInt(row.sizes["4xl"]),
					"5XL/46/18": parseInt(row.sizes["5xl"]),
					"One Size": parseInt(row.sizes["oneSize"]),
					36: parseInt(row.sizes["s-36"]),
					"36-5": parseInt(row.sizes["s-36-5"]),
					37: parseInt(row.sizes["s-37"]),
					"37-5": parseInt(row.sizes["s-37-5"]),
					38: parseInt(row.sizes["s-38"]),
					"38-5": parseInt(row.sizes["s-38-5"]),
					"39-5": parseInt(row.sizes["s-39-5"]),
					"40-5": parseInt(row.sizes["s-40-5"]),
					"41-5": parseInt(row.sizes["s-41-5"]),
					"42-5": parseInt(row.sizes["s-42-5"]),
					"43-5": parseInt(row.sizes["s-43-5"]),
					"44-5": parseInt(row.sizes["s-44-5"]),
					"45-5": parseInt(row.sizes["s-45-5"]),
					"46-5": parseInt(row.sizes["s-46-5"]),
					47: parseInt(row.sizes["s-47"]),
					"47-5": parseInt(row.sizes["s-47-5"]),
					48: parseInt(row.sizes["s-48"]),
					amount: parseInt(row["amount"]),
					הזמנה: [loadOrderData.loadedRecId],
					rawType: row.type,
				},
			};
		});

		const rowsToCreate = rowsToUpdate
			.filter((row) => !row.id)
			.map((row) => {
				return { fields: row.fields };
			});
		rowsToUpdate = rowsToUpdate.filter((row) => row.id);

		let size = 8;
		for (let i = 0; i < rowsToUpdate.length; i += size) {
			const tempRows = rowsToUpdate.slice(i, i + size);
			try {
				await base("פריטי הזמנות ספקים").update(tempRows);
			} catch (err) {
				console.error(err);
				alert("חלה שגיאה אנא נסו שוב");
				return;
			}
		}

		for (let i = 0; i < rowsToCreate.length; i += size) {
			const tempRows = rowsToCreate.slice(i, i + size);
			try {
				await base("פריטי הזמנות ספקים").create(tempRows);
			} catch (err) {
				console.error(err);
				alert("חלה שגיאה אנא נסו שוב");
				return;
			}
		}

		setOrderDone({
			done: true,
			orderId: loadOrderData.loadedOrderId,
			orderRecordId: loadOrderData.loadedRecId,
			updateUrl: loadOrderData.updateUrl,
			approveOrderUrl: checkApproveText,
			whatsappLink: whatsappLink,
			mailLink: mailLink,
		});

		// base("פריטי הזמנות").update(rowsToUpdate, function (err, records) {
		// 	if (err) {
		// 		console.error(err);
		// 		alert("חלה שגיאה אנא נסו שוב");
		// 		return;
		// 	}
		// });
	};

	const createOrder = async () => {
		// if (!selectedVendor || selectedVendor === "") {
		// 	alert("לא ניתן לבצע הזמנה ללא בחירת סוכן!");
		// 	return;
		// }

		if (!selectedSupplier || selectedSupplier === "") {
			alert("לא ניתן לבצע הזמנה ללא בחירת ספק!");
			return;
		}
		const input = [
			{
				fields: {
					ספק: [selectedSupplier],
					"הערות להזמנה": commentsField,
				},
			},
		];

		base("הזמנות ספקים").create(input, function (err, records) {
			if (err) {
				console.error(err);
				alert("חלה שגיאה אנא נסו שוב");
				return;
			}
			let newOrderRecId = records[0].id;
			let newOrderId = records[0].fields["מס הזמנה"];
			let orderUpdateUrl = records[0].fields["iframeUpdateOrderForm"];
			let checkApproveText = records[0].fields["checkApproveText"];
			let whatsappLink = records[0].fields["whatsappLink"];
			let mailLink = records[0].fields["mailLink"];
			uploadRowsAirtable(
				newOrderRecId,
				newOrderId,
				orderUpdateUrl,
				checkApproveText,
				whatsappLink,
				mailLink
			);
		});
	};

	const uploadRowsAirtable = async (
		orderRecordId,
		orderId,
		updateUrl,
		checkApproveText,
		whatsappLink,
		mailLink
	) => {
		var rowsToUpload = [];

		rowsToUpload = getAllRows().map((row) => {
			return {
				fields: {
					פריט: [row.id],
					"הערות/תיאור עבודה": row.comments,
					"מספר הזמנת לקוח": row.clientOrderId,
					"מיקום אספקה": row.location,
					"צבע הדפסה": row.printColorId,
					צבע: row.colorId,
					מחיר: row.price,
					2: parseInt(row.sizes["2"]),
					"S/39/4": parseInt(row.sizes["s"]),
					"M/40/6": parseInt(row.sizes["m"]),
					"L/41/8": parseInt(row.sizes["l"]),
					"XL/42/10": parseInt(row.sizes["xl"]),
					"2XL/43/12": parseInt(row.sizes["2xl"]),
					"3XL/44/14": parseInt(row.sizes["3xl"]),
					"4XL/45/16": parseInt(row.sizes["4xl"]),
					"5XL/46/18": parseInt(row.sizes["5xl"]),
					"One Size": parseInt(row.sizes["oneSize"]),
					36: parseInt(row.sizes["s-36"]),
					"36-5": parseInt(row.sizes["s-36-5"]),
					37: parseInt(row.sizes["s-37"]),
					"37-5": parseInt(row.sizes["s-37-5"]),
					38: parseInt(row.sizes["s-38"]),
					"38-5": parseInt(row.sizes["s-38-5"]),
					"39-5": parseInt(row.sizes["s-39-5"]),
					"40-5": parseInt(row.sizes["s-40-5"]),
					"41-5": parseInt(row.sizes["s-41-5"]),
					"42-5": parseInt(row.sizes["s-42-5"]),
					"43-5": parseInt(row.sizes["s-43-5"]),
					"44-5": parseInt(row.sizes["s-44-5"]),
					"45-5": parseInt(row.sizes["s-45-5"]),
					"46-5": parseInt(row.sizes["s-46-5"]),
					47: parseInt(row.sizes["s-47"]),
					"47-5": parseInt(row.sizes["s-47-5"]),
					48: parseInt(row.sizes["s-48"]),
					amount: parseInt(row["amount"]),
					rawType: row.type,
					הזמנה: [orderRecordId],
				},
			};
		});
		console.log(rowsToUpload);

		const size = 8;
		for (let i = 0; i < rowsToUpload.length; i += size) {
			const tempRows = rowsToUpload.slice(i, i + size);
			try {
				await base("פריטי הזמנות ספקים").create(tempRows);
			} catch (err) {
				console.error(err);
				alert("חלה שגיאה אנא נסו שוב");
				return;
			}
		}

		setOrderDone({
			done: true,
			orderId: orderId,
			updateUrl: updateUrl,
			approveOrderUrl: checkApproveText,
			whatsappLink: whatsappLink,
			mailLink: mailLink,
			orderRecordId: orderRecordId,
		});

		// base("פריטי הזמנות").create(rowsToUpload, function (err, records) {
		// 	if (err) {
		// 		console.error(err);
		// 		alert("חלה שגיאה אנא נסו שוב");
		// 		return;
		// 	}

		// 	setOrderDone({
		// 		done: true,
		// 		orderId: orderId,
		// 		updateUrl: updateUrl,
		// 		approveOrderUrl: checkApproveText,
		// 		orderRecordId: orderRecordId,
		// 	});
		// });
	};

	const isImportedOrder = () => {
		return (
			loadOrderData.loadedRecId != null && loadOrderData.loadedRecId !== ""
		);
	};

	const countSizes = (sizes) => {
		if (!sizes || sizes.length === 0) return 0;

		let counter = Object.values(sizes).reduce((prev, current) => {
			let num2 = current ? parseInt(current) : 0;
			return prev + num2;
		}, 0);
		return counter ? counter : 0;
	};

	const getAllRows = () => {
		let allRows = [];
		for (let i = 0; i < Object.keys(rows).length; i++) {
			const key = Object.keys(rows)[i];
			const sortedRows = rows[key].map((row) => {
				row.type = key;
				return row;
			});
			allRows = allRows.concat(sortedRows);
		}
		return allRows;
	};

	const orderItemsCounter = () => {
		let count = 0;
		const allRows = getAllRows();
		for (let i = 0; i < allRows.length; i++) {
			let row = allRows[i];
			let rowCount = 0;

			if (row.type === "מוצרי פרסום" || row.type === "דפוס ומשרד")
				rowCount = parseInt(row.amount);
			else rowCount = countSizes(row.sizes);

			count += rowCount;
		}
		return count;
	};

	const orderSum = () => {
		let sum = 0;
		//const allRows = getAllRows();
		for (let i = 0; i < rows.נעליים.length; i++) {
			let row = rows.נעליים[i];
			let rowCount = countSizes(row.sizes);
			let itemPrice = row.price ?? getProductPrice(i, row.type);
			sum += rowCount * itemPrice;
		}

		for (let i = 0; i < rows.ילדים.length; i++) {
			let row = rows.ילדים[i];
			let rowCount = countSizes(row.sizes);
			let itemPrice = row.price ?? getProductPrice(i, row.type);
			sum += rowCount * itemPrice;
		}

		for (let i = 0; i < rows.בוגרים.length; i++) {
			let row = rows.בוגרים[i];
			let rowCount = countSizes(row.sizes);
			let itemPrice = row.price ?? getProductPrice(i, row.type);
			sum += rowCount * itemPrice;
		}

		for (let i = 0; i < rows["מוצרי פרסום"].length; i++) {
			let row = rows["מוצרי פרסום"][i];
			let rowCount = row.amount;
			let itemPrice = row.price ?? getProductPrice(i, row.type);
			sum += rowCount * itemPrice;
		}

		for (let i = 0; i < rows["דפוס ומשרד"].length; i++) {
			let row = rows["דפוס ומשרד"][i];
			let rowCount = row.amount;
			let itemPrice = row.price ?? getProductPrice(i, row.type);
			sum += rowCount * itemPrice;
		}
		return sum;
	};

	const orderSumBeforeDiscount = () => {
		let sum = 0;
		for (let i = 0; i < rows.נעליים.length; i++) {
			let row = rows.נעליים[i];
			let rowCount = countSizes(row.sizes);
			let itemPrice = getProductPrice(i, row.type);
			sum += rowCount * itemPrice;
		}

		for (let i = 0; i < rows.ילדים.length; i++) {
			let row = rows.ילדים[i];
			let rowCount = countSizes(row.sizes);
			let itemPrice = getProductPrice(i, row.type);
			sum += rowCount * itemPrice;
		}

		for (let i = 0; i < rows.בוגרים.length; i++) {
			let row = rows.בוגרים[i];
			let rowCount = countSizes(row.sizes);
			let itemPrice = getProductPrice(i, row.type);
			sum += rowCount * itemPrice;
		}

		for (let i = 0; i < rows["מוצרי פרסום"].length; i++) {
			let row = rows["מוצרי פרסום"][i];
			let rowCount = row.amount;
			let itemPrice = getProductPrice(i, row.type);
			sum += rowCount * itemPrice;
		}

		for (let i = 0; i < rows["דפוס ומשרד"].length; i++) {
			let row = rows["דפוס ומשרד"][i];
			let rowCount = row.amount;
			let itemPrice = getProductPrice(i, row.type);
			sum += rowCount * itemPrice;
		}
		return sum;
	};

	const getItemSelectOptions = (supplier, type) => {
		const withPrints = type === "ילדים" || type === "בוגרים";
		return [
			...data
				.filter(
					(item) =>
						item.fields["ספק"] &&
						item.fields["ספק"].includes(supplier) &&
						(type === "" ||
							item.fields.type === type ||
							(withPrints && item.fields.type === "הדפסים"))
				)
				.map((item) => {
					return { value: item.id, label: item.fields.Name };
				}),
		];
	};

	const TableRow = ({
		idx,
		itemId = null,
		colorId = null,
		sizes = {},
		comments = null,
		clientOrderId = null,
		price = null,
		type = "",
		supplier = null,
	}) => {
		let itemOptions = getItemSelectOptions(supplier, type);
		let sizesCounter = countSizes(sizes);
		const onBlurRow = (e) => sizeChanged(e, idx, type);
		return (
			<tr>
				<td>
					<Button
						variant="danger"
						size="sm"
						onClick={(e) => {
							let newRowsType = [...rows[type]];

							if (isImportedOrder()) {
								setRowsToDelete([...rowsToDelete, newRowsType[idx].recId]);
							}

							newRowsType.splice(idx, 1);
							const newRows = { ...rows };
							newRows[type] = newRowsType;
							setRows(newRows);
						}}
					>
						X
					</Button>
				</td>

				<td>
					<div style={{ width: "200px", fontSize: "14px" }}>
						<Select
							value={itemOptions.filter(function (option) {
								return option.value === itemId;
							})}
							placeholder="בחר פריט..."
							menuPortalTarget={document.querySelector("body")}
							onChange={(value) => {
								let newRowsType = [...rows[type]];
								const productInfo = data.find(
									(item) => item.id === value.value
								);
								newRowsType[idx] = {
									id: value.value,
									checkboxData: newRowsType[idx].checkboxData,
									comments: newRowsType[idx].comments,
									sizes: newRowsType[idx].sizes,
									recId: newRowsType[idx].recId,
									type: type,
									price: productInfo.fields.price,
								};

								const newRows = { ...rows };
								newRows[type] = newRowsType;

								setRows(newRows);
							}}
							options={itemOptions}
						/>
					</div>

					{/* <select
						value={itemId ?? ""}
						onChange={(e) => {
							let newRows = [...rows];
							newRows[idx] = {
								id: e.target.value,
								checkboxData: newRows[idx].checkboxData,
								comments: newRows[idx].comments,
								sizes: newRows[idx].sizes,
								recId: newRows[idx].recId,
							};

							setRows(newRows);
						}}
					>
						<option value="">בחר פריט</option>
						{data.map((item, index) => {
							return (
								<option key={item.id} value={item.id}>
									{item.fields.Name}
								</option>
							);
						})}
					</select> */}
				</td>
				<td>
					<select
						value={colorId ?? ""}
						onChange={(e) => {
							let newRowsType = [...rows[type]];
							newRowsType[idx] = {
								...newRowsType[idx],
								colorId: e.target.value,
							};

							const newRows = { ...rows };
							newRows[type] = newRowsType;

							setRows(newRows);
						}}
					>
						<option value="">בחר צבע</option>
						<ColorSelector itemId={itemId} />
					</select>
				</td>
				{type === "נעליים" ? (
					<>
						<td>
							<input
								type="number"
								className="size-input input-0"
								min="0"
								defaultValue={sizes["s-36"] ?? ""}
								onBlur={onBlurRow}
								data-size="s-36"
							/>
						</td>
						<td>
							<input
								type="number"
								className="size-input input-0"
								min="0"
								defaultValue={sizes["s-36-5"] ?? ""}
								onBlur={onBlurRow}
								data-size="s-36-5"
							/>
						</td>
						<td>
							<input
								type="number"
								className="size-input input-0"
								min="0"
								defaultValue={sizes["s-37"] ?? ""}
								onBlur={onBlurRow}
								data-size="s-37"
							/>
						</td>
						<td>
							<input
								type="number"
								className="size-input input-0"
								min="0"
								defaultValue={sizes["s-37-5"] ?? ""}
								onBlur={onBlurRow}
								data-size="s-37-5"
							/>
						</td>
						<td>
							<input
								type="number"
								className="size-input input-0"
								min="0"
								defaultValue={sizes["s-38"] ?? ""}
								onBlur={onBlurRow}
								data-size="s-38"
							/>
						</td>
						<td>
							<input
								type="number"
								className="size-input input-0"
								min="0"
								defaultValue={sizes["s-38-5"] ?? ""}
								onBlur={onBlurRow}
								data-size="s-38-5"
							/>
						</td>
					</>
				) : (
					""
				)}
				{type === "ילדים" && (
					<td>
						<input
							type="number"
							className="size-input"
							min="0"
							defaultValue={sizes["2"] ?? ""}
							onBlur={onBlurRow}
							data-size="2"
						/>
					</td>
				)}
				<td>
					<input
						type="number"
						className="size-input input-0"
						min="0"
						defaultValue={sizes["s"] ?? ""}
						onBlur={onBlurRow}
						data-size="s"
					/>
				</td>
				{type === "נעליים" ? (
					<td>
						<input
							type="number"
							className="size-input input-0"
							min="0"
							defaultValue={sizes["s-39-5"] ?? ""}
							onBlur={onBlurRow}
							data-size="s-39-5"
						/>
					</td>
				) : (
					""
				)}
				<td>
					<input
						type="number"
						className="size-input input-1"
						min="0"
						defaultValue={sizes["m"] ?? ""}
						onBlur={onBlurRow}
						data-size="m"
					/>
				</td>
				{type === "נעליים" ? (
					<td>
						<input
							type="number"
							className="size-input input-0"
							min="0"
							defaultValue={sizes["s-40-5"] ?? ""}
							onBlur={onBlurRow}
							data-size="s-40-5"
						/>
					</td>
				) : (
					""
				)}
				<td>
					<input
						type="number"
						className="size-input"
						min="0"
						defaultValue={sizes["l"] ?? ""}
						onBlur={onBlurRow}
						data-size="l"
					/>
				</td>
				{type === "נעליים" ? (
					<td>
						<input
							type="number"
							className="size-input input-0"
							min="0"
							defaultValue={sizes["s-41-5"] ?? ""}
							onBlur={onBlurRow}
							data-size="s-41-5"
						/>
					</td>
				) : (
					""
				)}
				<td>
					<input
						type="number"
						className="size-input"
						min="0"
						defaultValue={sizes["xl"] ?? ""}
						onBlur={onBlurRow}
						data-size="xl"
					/>
				</td>
				{type === "נעליים" ? (
					<td>
						<input
							type="number"
							className="size-input input-0"
							min="0"
							defaultValue={sizes["s-42-5"] ?? ""}
							onBlur={onBlurRow}
							data-size="s-42-5"
						/>
					</td>
				) : (
					""
				)}
				<td>
					<input
						type="number"
						className="size-input"
						min="0"
						defaultValue={sizes["2xl"] ?? ""}
						onBlur={onBlurRow}
						data-size="2xl"
					/>
				</td>
				{type === "נעליים" ? (
					<td>
						<input
							type="number"
							className="size-input input-0"
							min="0"
							defaultValue={sizes["s-43-5"] ?? ""}
							onBlur={onBlurRow}
							data-size="s-43-5"
						/>
					</td>
				) : (
					""
				)}
				<td>
					<input
						type="number"
						className="size-input"
						min="0"
						defaultValue={sizes["3xl"] ?? ""}
						onBlur={onBlurRow}
						data-size="3xl"
					/>
				</td>
				{type === "נעליים" ? (
					<td>
						<input
							type="number"
							className="size-input input-0"
							min="0"
							defaultValue={sizes["s-44-5"] ?? ""}
							onBlur={onBlurRow}
							data-size="s-44-5"
						/>
					</td>
				) : (
					""
				)}
				<td>
					<input
						type="number"
						className="size-input"
						min="0"
						defaultValue={sizes["4xl"] ?? ""}
						onBlur={onBlurRow}
						data-size="4xl"
					/>
				</td>
				{type === "נעליים" ? (
					<td>
						<input
							type="number"
							className="size-input input-0"
							min="0"
							defaultValue={sizes["s-45-5"] ?? ""}
							onBlur={onBlurRow}
							data-size="s-45-5"
						/>
					</td>
				) : (
					""
				)}
				<td>
					<input
						type="number"
						className="size-input"
						min="0"
						defaultValue={sizes["5xl"] ?? ""}
						onBlur={onBlurRow}
						data-size="5xl"
					/>
				</td>
				{type === "נעליים" ? (
					<>
						<td>
							<input
								type="number"
								className="size-input input-0"
								min="0"
								defaultValue={sizes["s-46-5"] ?? ""}
								onBlur={onBlurRow}
								data-size="s-46-5"
							/>
						</td>
						<td>
							<input
								type="number"
								className="size-input input-0"
								min="0"
								defaultValue={sizes["s-47"] ?? ""}
								onBlur={onBlurRow}
								data-size="s-47"
							/>
						</td>
						<td>
							<input
								type="number"
								className="size-input input-0"
								min="0"
								defaultValue={sizes["s-47-5"] ?? ""}
								onBlur={onBlurRow}
								data-size="s-47-5"
							/>
						</td>
						<td>
							<input
								type="number"
								className="size-input input-0"
								min="0"
								defaultValue={sizes["s-48"] ?? ""}
								onBlur={onBlurRow}
								data-size="s-48"
							/>
						</td>
					</>
				) : (
					""
				)}
				{type === "בוגרים" && (
					<td>
						<input
							type="number"
							className="size-input"
							min="0"
							defaultValue={sizes["oneSize"] ?? ""}
							onBlur={onBlurRow}
							data-size="oneSize"
						/>
					</td>
				)}
				<td>{sizesCounter}</td>
				<td>{getProductPrice(idx, type) + "₪" ?? ""}</td>
				<td>
					{(sizesCounter * (price ?? getProductPrice(idx, type))).toFixed(1)}
					&nbsp;₪
				</td>
				<td>
					<input
						type="text"
						defaultValue={comments}
						placeholder="הערות"
						onBlur={(e) => {
							let newRowsType = [...rows[type]];
							newRowsType[idx].comments = e.target.value;

							const newRows = { ...rows };
							newRows[type] = newRowsType;

							setRows(newRows);
						}}
					/>
				</td>
				<td>
					<input
						type="text"
						defaultValue={clientOrderId}
						placeholder="מס׳ הזמנת לקוח"
						onBlur={(e) => {
							let newRowsType = [...rows[type]];
							newRowsType[idx].clientOrderId = e.target.value;

							const newRows = { ...rows };
							newRows[type] = newRowsType;

							setRows(newRows);
						}}
					/>
				</td>
			</tr>
		);
	};

	const TableRowMarketing = ({
		idx,
		itemId = null,
		makat = null,
		colorId = null,
		amount = null,
		price = null,
		printColorId = null,
		comments = null,
		location = null,
		clientOrderId = null,
		supplier = null,
	}) => {
		console.log(data[itemId]);
		const type = "מוצרי פרסום";
		let itemOptions = getItemSelectOptions(supplier, type);
		makat = getProduct(idx, type)["מקט ספק"];

		return (
			<tr>
				<td>
					<Button
						variant="danger"
						size="sm"
						onClick={(e) => {
							let newRowsType = [...rows[type]];

							if (isImportedOrder()) {
								setRowsToDelete([...rowsToDelete, newRowsType[idx].recId]);
							}

							newRowsType.splice(idx, 1);
							const newRows = { ...rows };
							newRows[type] = newRowsType;
							setRows(newRows);
						}}
					>
						X
					</Button>
				</td>
				<td>
					<div style={{ width: "200px", fontSize: "14px" }}>
						<Select
							value={itemOptions.filter(function (option) {
								return option.value === itemId;
							})}
							placeholder="בחר פריט..."
							menuPortalTarget={document.querySelector("body")}
							onChange={(value) => {
								let newRowsType = [...rows[type]];
								const productInfo = data.find(
									(item) => item.id === value.value
								);
								newRowsType[idx] = {
									id: value.value,
									checkboxData: newRowsType[idx].checkboxData,
									comments: newRowsType[idx].comments,
									sizes: newRowsType[idx].sizes,
									recId: newRowsType[idx].recId,
									type: type,
									price: productInfo.fields.price,
								};

								const newRows = { ...rows };
								newRows[type] = newRowsType;

								setRows(newRows);
							}}
							options={itemOptions}
						/>
					</div>
				</td>
				<td>{makat ?? ""}</td>
				<td>
					<select
						value={colorId ?? ""}
						onChange={(e) => {
							let newRowsType = [...rows[type]];
							newRowsType[idx] = {
								...newRowsType[idx],
								colorId: e.target.value,
							};

							const newRows = { ...rows };
							newRows[type] = newRowsType;

							setRows(newRows);
						}}
					>
						<option value="">בחר צבע</option>
						<ColorSelector itemId={itemId} />
					</select>
				</td>
				<td>
					<input
						type="number"
						className="size-input"
						defaultValue={amount}
						step="1"
						placeholder="כמות"
						onBlur={(e) => {
							let newRowsType = [...rows[type]];
							newRowsType[idx].amount = e.target.value;

							const newRows = { ...rows };
							newRows[type] = newRowsType;

							setRows(newRows);
						}}
					/>
				</td>
				<td>{getProductPrice(idx, type) + "₪" ?? ""}</td>
				<td>
					{(amount * (price ?? getProductPrice(idx, type))).toFixed(1)}
					&nbsp;₪
				</td>
				<td>
					<input
						type="text"
						defaultValue={printColorId}
						placeholder="צבע הדפסה"
						onBlur={(e) => {
							let newRowsType = [...rows[type]];
							newRowsType[idx].printColorId = e.target.value;

							const newRows = { ...rows };
							newRows[type] = newRowsType;

							setRows(newRows);
						}}
					/>
				</td>
				<td>
					<input
						type="text"
						defaultValue={comments}
						placeholder="תיאור עבודה"
						onBlur={(e) => {
							let newRowsType = [...rows[type]];
							newRowsType[idx].comments = e.target.value;

							const newRows = { ...rows };
							newRows[type] = newRowsType;

							setRows(newRows);
						}}
					/>
				</td>
				<td>
					<input
						type="text"
						defaultValue={location}
						placeholder="מיקום אספקה"
						onBlur={(e) => {
							let newRowsType = [...rows[type]];
							newRowsType[idx].location = e.target.value;

							const newRows = { ...rows };
							newRows[type] = newRowsType;

							setRows(newRows);
						}}
					/>
				</td>
				<td>
					<input
						type="text"
						defaultValue={clientOrderId}
						placeholder="מספר הזמנת לקוח"
						onBlur={(e) => {
							let newRowsType = [...rows[type]];
							newRowsType[idx].clientOrderId = e.target.value;

							const newRows = { ...rows };
							newRows[type] = newRowsType;

							setRows(newRows);
						}}
					/>
				</td>
			</tr>
		);
	};

	const TableRowOffice = ({
		idx,
		itemId = null,
		makat = null,
		amount = null,
		price = null,
		comments = null,
		supplier = null,
	}) => {
		const type = "דפוס ומשרד";
		let itemOptions = getItemSelectOptions(supplier, type);
		makat = getProduct(idx, type)["מקט ספק"];
		return (
			<tr>
				<td>
					<Button
						variant="danger"
						size="sm"
						onClick={(e) => {
							let newRowsType = [...rows[type]];

							if (isImportedOrder()) {
								setRowsToDelete([...rowsToDelete, newRowsType[idx].recId]);
							}

							newRowsType.splice(idx, 1);
							const newRows = { ...rows };
							newRows[type] = newRowsType;
							setRows(newRows);
						}}
					>
						X
					</Button>
				</td>
				<td>
					<div style={{ width: "200px", fontSize: "14px" }}>
						<Select
							value={itemOptions.filter(function (option) {
								return option.value === itemId;
							})}
							placeholder="בחר פריט..."
							menuPortalTarget={document.querySelector("body")}
							onChange={(value) => {
								let newRowsType = [...rows[type]];
								const productInfo = data.find(
									(item) => item.id === value.value
								);
								newRowsType[idx] = {
									id: value.value,
									checkboxData: newRowsType[idx].checkboxData,
									comments: newRowsType[idx].comments,
									sizes: newRowsType[idx].sizes,
									recId: newRowsType[idx].recId,
									type: type,
									price: productInfo.fields.price,
								};

								const newRows = { ...rows };
								newRows[type] = newRowsType;

								setRows(newRows);
							}}
							options={itemOptions}
						/>
					</div>
				</td>
				<td>{makat ?? ""}</td>
				<td>
					<input
						type="number"
						className="size-input"
						defaultValue={amount}
						step="1"
						placeholder="כמות"
						onBlur={(e) => {
							let newRowsType = [...rows[type]];
							newRowsType[idx].amount = e.target.value;

							const newRows = { ...rows };
							newRows[type] = newRowsType;

							setRows(newRows);
						}}
					/>
				</td>
				<td>{getProductPrice(idx, type) + "₪" ?? ""}</td>
				<td>
					{(amount * (price ?? getProductPrice(idx, type))).toFixed(1)}
					&nbsp;₪
				</td>
				<td>
					<input
						type="text"
						defaultValue={comments}
						placeholder="הערות"
						onBlur={(e) => {
							let newRowsType = [...rows[type]];
							newRowsType[idx].comments = e.target.value;

							const newRows = { ...rows };
							newRows[type] = newRowsType;

							setRows(newRows);
						}}
					/>
				</td>
			</tr>
		);
	};

	let supplierData = getSupplierData();

	let itemsCounter = orderItemsCounter();

	let totalPrice = orderSum();
	let totalPriceBeforeDiscount = orderSumBeforeDiscount();
	let discountPercentage = (1 - totalPrice / totalPriceBeforeDiscount) * 100;

	let sortedSuppliers = suppliers.map((supplier) => {
		return { value: supplier.id, label: supplier.fields["שם הספק"] };
	});

	return (
		<div className="App" id="App">
			<div style={{ textAlign: "center" }}>
				<img height="100" alt="logo" src={logo} />
				<div style={{ color: "#804c9e", fontWeight: "bold" }}>
					תמנע 7 חולון 5881307 | טל' 03-5580668 | פקס 03-5591101
					<br />
					ח.פ 513830638 | www.sigal-ba.co.il
					<h3 style={{ fontWeight: "bold" }}>הנפקת הזמנת רכש</h3>
				</div>
			</div>
			{orderDone.done ? (
				<div style={{ textAlign: "center" }}>
					<h3>
						{orderDone.approveOrderUrl?.includes("מנהל")
							? orderDone.approveOrderUrl
							: isImportedOrder()
							? "ההזמנה עודכנה בהצלחה!"
							: "ההזמנה בוצעה בהצלחה!"}
					</h3>
					<h5>מספר הזמנת רכש: {orderDone.orderId}</h5>
					<h6>
						קישור לסיכום הזמנת רכש:
						<br />
						<a
							href={`https://sigal-steel.vercel.app/supplier/${orderDone.orderRecordId}`}
							target="_blank"
							rel="noopener noreferrer"
							style={{ fontSize: "20px", fontWeight: "bold" }}
						>
							https://sigal-steel.vercel.app/supplier/
							{orderDone.orderRecordId}
						</a>
					</h6>
					<h6>
						קישור לטופס בדיקת סחורה:
						<br />
						<a
							href={`https://sigal-steel.vercel.app/supplier/fulfillment/${orderDone.orderRecordId}`}
							target="_blank"
							rel="noopener noreferrer"
							style={{ fontSize: "20px", fontWeight: "bold" }}
						>
							https://sigal-steel.vercel.app/supplier/fulfillment/
							{orderDone.orderRecordId}
						</a>
					</h6>
					<br />
					{orderDone.mailLink && orderDone.mailLink !== "" && (
						<a
							href={orderDone.mailLink}
							target="_blank"
							rel="noopener noreferrer"
						>
							<Button variant="danger" style={{ margin: "5px" }}>
								שלח מייל לספק
							</Button>
						</a>
					)}

					{orderDone.whatsappLink && orderDone.whatsappLink !== "" && (
						<a
							href={orderDone.whatsappLink}
							target="_blank"
							rel="noopener noreferrer"
						>
							<Button variant="warning" style={{ margin: "5px" }}>
								שלח ווצאפ לספק
							</Button>
						</a>
					)}
					<Button
						variant="success"
						style={{ margin: "5px" }}
						onClick={() => {
							window.location.reload();
						}}
					>
						בצע הזמנה נוספת
					</Button>
				</div>
			) : (
				<div>
					<div style={{ display: "flex", justifyContent: "space-between" }}>
						<label>
							<b>ספק:</b> &nbsp;
							<Select
								style={{ display: "inline-block" }}
								value={sortedSuppliers.filter(function (option) {
									return option.value === selectedSupplier;
								})}
								placeholder="בחר ספק..."
								onChange={(value) => {
									setSelectedSupplier(value.value);
								}}
								options={sortedSuppliers}
							/>
						</label>
						<div style={{ textAlign: "center" }}>
							עריכת הזמנה:
							<Form.Control
								onBlur={(e) => {
									setLoadOrderData({
										...loadOrderData,
										orderId: e.target.value,
									});
								}}
								size="sm"
								type="text"
								placeholder="מספר הזמנת רכש"
							/>
							<Button
								size="sm"
								variant="secondary"
								style={{ margin: "5px" }}
								onClick={() => {
									loadOrder();
								}}
							>
								טען הזמנה
							</Button>
						</div>
					</div>

					<br />
					{isImportedOrder() ? (
						<h4 style={{ textAlign: "center" }}>
							עריכת הזמנה מס': {loadOrderData.loadedOrderId}
							<Button
								variant="danger"
								size="sm"
								style={{ margin: "5px" }}
								onClick={() => {
									window.location.reload();
								}}
							>
								ביטול עריכה
							</Button>
						</h4>
					) : (
						<></>
					)}
					<br />
					{selectedSupplier && selectedSupplier !== "" ? (
						<>
							<div
								style={{
									display: "flex",
									justifyContent: "center",
									flexWrap: "wrap",
									gap: "25px",
									fontSize: "18px",
								}}
							>
								<div>
									<b>שם הספק: </b>
									{supplierData["שם הספק"]}
								</div>
								<div>
									<b>טלפון: </b>
									{supplierData["phoneParsed"]}
								</div>
								<div>
									<b>אימייל: </b>
									{supplierData["אימייל"]}
								</div>
								<div>
									<b>ח"פ\ע"מ: </b>
									{supplierData["ח.פ"]}
								</div>
								<div>
									<b>כתובת: </b>
									{supplierData["כתובת"]}
								</div>
							</div>
							<br></br>
						</>
					) : (
						" "
					)}

					<h4>
						בוגרים{" "}
						<Button
							variant="secondary"
							size="sm"
							onClick={() => {
								setRows({
									...rows,
									בוגרים: [
										{ id: null, sizes: {}, type: "בוגרים" },
										...rows["בוגרים"],
									],
								});
							}}
						>
							הוסף שורה
						</Button>
					</h4>
					<Table
						id="tables"
						size={"sm"}
						responsive
						bordered
						style={{ textAlign: "center" }}
					>
						<thead>
							<tr>
								<th>מחיקה</th>
								<th>סוג פריט</th>
								<th>צבע</th>
								<th>S</th>
								<th>M</th>
								<th>L</th>
								<th>XL</th>
								<th>2XL</th>
								<th>3XL</th>
								<th>4XL</th>
								<th>5XL</th>
								<th>ONE SIZE</th>
								<th>כמות</th>
								<th>מחיר ליח'</th>
								<th>מחיר כולל</th>
								<th>הערות</th>
								<th>מס׳ הזמנת לקוח</th>
							</tr>
						</thead>
						<tbody>
							{rows["בוגרים"].map((item, idx) => (
								<TableRow
									idx={idx}
									key={idx}
									itemId={item.id}
									colorId={item.colorId}
									sizes={item.sizes}
									comments={item.comments}
									clientOrderId={item.clientOrderId}
									price={item.price}
									type={"בוגרים"}
									supplier={selectedSupplier}
								/>
							))}
						</tbody>
					</Table>
					<hr />
					<h4>
						ילדים{" "}
						<Button
							variant="secondary"
							size="sm"
							onClick={() => {
								setRows({
									...rows,
									ילדים: [
										...rows["ילדים"],
										{ id: null, sizes: {}, type: "ילדים" },
									],
								});
							}}
						>
							הוסף שורה
						</Button>
					</h4>
					<Table
						id="tables"
						size={"sm"}
						responsive
						bordered
						style={{ textAlign: "center" }}
					>
						<thead>
							<tr>
								<th>מחיקה</th>
								<th>סוג פריט</th>
								<th>צבע</th>
								<th>2</th>
								<th>4</th>
								<th>6</th>
								<th>8</th>
								<th>10</th>
								<th>12</th>
								<th>14</th>
								<th>16</th>
								<th>18</th>
								<th>כמות</th>
								<th>מחיר ליח'</th>
								<th>מחיר כולל</th>
								<th>הערות</th>
								<th>מס׳ הזמנת לקוח</th>
							</tr>
						</thead>
						<tbody>
							{rows["ילדים"].map((item, idx) => (
								<TableRow
									idx={idx}
									key={idx}
									itemId={item.id}
									colorId={item.colorId}
									sizes={item.sizes}
									comments={item.comments}
									clientOrderId={item.clientOrderId}
									price={item.price}
									type={"ילדים"}
									supplier={selectedSupplier}
								/>
							))}
						</tbody>
					</Table>
					<hr />
					<h4>
						נעליים{" "}
						<Button
							variant="secondary"
							size="sm"
							onClick={() => {
								setRows({
									...rows,
									נעליים: [
										...rows["נעליים"],
										{ id: null, sizes: {}, type: "נעליים" },
									],
								});
							}}
						>
							הוסף שורה
						</Button>
					</h4>
					<Table
						id="tables"
						size={"sm"}
						responsive
						bordered
						style={{ textAlign: "center" }}
					>
						<thead>
							<tr>
								<th>מחיקה</th>
								<th>סוג פריט</th>
								<th>צבע</th>
								<th>36</th>
								<th>36.5</th>
								<th>37</th>
								<th>37.5</th>
								<th>38</th>
								<th>38.5</th>
								<th>39</th>
								<th>39.5</th>
								<th>40</th>
								<th>40.5</th>
								<th>41</th>
								<th>41.5</th>
								<th>42</th>
								<th>42.5</th>
								<th>43</th>
								<th>43.5</th>
								<th>44</th>
								<th>44.5</th>
								<th>45</th>
								<th>45.5</th>
								<th>46</th>
								<th>46.5</th>
								<th>47</th>
								<th>47.5</th>
								<th>48</th>
								<th>כמות</th>
								<th>מחיר ליח'</th>
								<th>מחיר כולל</th>
								<th>הערות</th>
								<th>מס׳ הזמנת לקוח</th>
							</tr>
						</thead>
						<tbody>
							{rows["נעליים"].map((item, idx) => (
								<TableRow
									idx={idx}
									key={idx}
									itemId={item.id}
									colorId={item.colorId}
									sizes={item.sizes}
									comments={item.comments}
									price={item.price}
									clientOrderId={item.clientOrderId}
									type={"נעליים"}
									supplier={selectedSupplier}
								/>
							))}
						</tbody>
					</Table>
					<hr />
					<h4>
						מוצרי פרסום{" "}
						<Button
							variant="secondary"
							size="sm"
							onClick={() => {
								setRows({
									...rows,
									"מוצרי פרסום": [
										...rows["מוצרי פרסום"],
										{ id: null, sizes: {}, type: "מוצרי פרסום" },
									],
								});
							}}
						>
							הוסף שורה
						</Button>
					</h4>
					<Table
						id="tables"
						size={"sm"}
						responsive
						bordered
						style={{ textAlign: "center" }}
					>
						<thead>
							<tr>
								<th>מחיקה</th>
								<th>סוג פריט</th>
								<th>מק״ט ספק</th>
								<th>צבע</th>
								<th>כמות</th>
								<th>מחיר ליח'</th>
								<th>מחיר כולל</th>
								<th>צבע הדפסה</th>
								<th>תיאור עבודה</th>
								<th>מיקום אספקה</th>
								<th>מס׳ הזמנת לקוח</th>
							</tr>
						</thead>
						<tbody>
							{rows["מוצרי פרסום"].map((item, idx) => (
								<TableRowMarketing
									key={idx}
									idx={idx}
									itemId={item.id}
									colorId={item.colorId}
									amount={item.amount}
									price={item.price}
									printColorId={item.printColorId}
									makat={item.makat}
									comments={item.comments}
									location={item.location}
									clientOrderId={item.clientOrderId}
									supplier={selectedSupplier}
								/>
							))}
						</tbody>
					</Table>
					<hr />
					<h4>
						דפוס ומשרד{" "}
						<Button
							variant="secondary"
							size="sm"
							onClick={() => {
								setRows({
									...rows,
									"דפוס ומשרד": [
										...rows["דפוס ומשרד"],
										{ id: null, sizes: {}, type: "דפוס ומשרד" },
									],
								});
							}}
						>
							הוסף שורה
						</Button>
					</h4>
					<Table
						id="tables"
						size={"sm"}
						responsive
						bordered
						style={{ textAlign: "center" }}
					>
						<thead>
							<tr>
								<th>מחיקה</th>
								<th>סוג פריט</th>
								<th>מק״ט ספק</th>
								<th>כמות</th>
								<th>מחיר ליח'</th>
								<th>מחיר כולל</th>
								<th>הערות</th>
							</tr>
						</thead>
						<tbody>
							{rows["דפוס ומשרד"].map((item, idx) => (
								<TableRowOffice
									key={idx}
									idx={idx}
									itemId={item.id}
									amount={item.amount}
									price={item.price}
									makat={item.makat}
									comments={item.comments}
									supplier={selectedSupplier}
								/>
							))}
						</tbody>
					</Table>
					<br />
					<div
						style={{
							display: "flex",
							justifyContent: "space-evenly",
							fontWeight: "bold",
						}}
					>
						<div>כמות פריטים: {itemsCounter}</div>
						{discountPercentage > 0 && (
							<div>הנחה: {discountPercentage.toFixed(0)}%</div>
						)}
						<div>סכום הזמנה: {totalPrice.toFixed(1)} ₪</div>
						<div>מע"מ: {(totalPrice * taxPercent).toFixed(1)} ₪</div>
						<div>
							סכום הזמנה (כולל מע"מ):{" "}
							{(totalPrice * (1 + taxPercent)).toFixed(1)} ₪
						</div>
					</div>
					<br />

					<div
						style={{
							display: "flex",
							alignItems: "center",
							gap: "8px",
							flexDirection: "column",
						}}
					>
						<label htmlFor="commentsField">
							הערות:
							<br />
							<textarea
								onChange={(e) => setCommentsField(e.target.value)}
								cols="50"
								rows="3"
								id="commentsField"
								defaultValue={commentsField}
								key={"comments" + loadOrderData.loadedRecId}
							></textarea>
						</label>
					</div>
					<br />
					<div style={{ textAlign: "center" }}>
						<Button
							variant="success"
							style={{ margin: "5px", marginRight: "10px" }}
							onClick={() => {
								if (isImportedOrder()) {
									updateRows();
								} else {
									createOrder();
								}
							}}
						>
							{isImportedOrder() ? "עדכן הזמנה" : "צור הזמנה"}
						</Button>
					</div>
				</div>
			)}
		</div>
	);
}

export default SmallSizes;
